/**
 * ¿TIENE YA MACROS DE VERDAD QUE REPARTIR?
 *
 * FICHA 05 del parte de Gonzalo del 4-09 («el tutorial va antes de la bienvenida, y habla de
 * lo que no tiene»), cerrada el 13-09 a petición de Francisco.
 *
 * El recorrido de la primera vez habla de repartir «tus macros» en tus comidas -- es
 * literalmente el título de su primer paso, «Aquí creas lo que vas a comer» --, y arrancaba
 * mirando solo si el alta constaba hecha. Pero «alta hecha» y «tiene macros» no son lo mismo:
 * hay fichas con `questionnaire_completed` en true y `macros_training` vacío (el 500 del alta
 * que dejaba el cuestionario por contestado sin llegar a calcular, y las importadas de Calma).
 * A esa persona se le montaban cinco tarjetas explicándole cómo repartir unos números que no
 * existen, encima de un Inicio que al mismo tiempo le pedía «Configura tus macros». Son 3
 * fichas en dev.
 *
 * Vive aquí y no dentro del contexto porque el contexto arrastra react-router, y con la v7
 * (ESM) los tests no pueden ni importarlo: la lógica pura se prueba, el contexto la usa.
 *
 * Lee los macros en los DOS idiomas: hay fichas con `protein` y fichas con `proteinas`
 * (ver `dos-juegos-de-macros`).
 */
export const tieneMacrosQueRepartir = (perfil) => {
    const m = perfil?.macros_training;
    if (!m) return false;
    return Number(m.protein) > 0 || Number(m.proteinas) > 0;
};

export default tieneMacrosQueRepartir;
